import { Field, connect } from 'formik';
import PropTypes from 'prop-types';

import Error from 'hb-react/shared/components/formik/components/Error';
import Wrapper from 'hb-react/shared/components/formik/components/Wrapper';

import { validateHidden } from './validate';

const Hidden = ({
  disabled,
  name,
  id,
  validate = {},
  wrapperHtml = {},
  inputHtml = {},
}) => {
  const {
    required,
    minimum,
    maximum,
    maxLength,
    maximumNumberOfDecimals,
    validateFunc,
  } = validate;

  return (
    <Wrapper name={name} withoutCSS {...wrapperHtml}>
      <Field
        disabled={disabled}
        type="hidden"
        name={name}
        id={id}
        validate={(value) =>
          validateHidden({
            value,
            required,
            minimum,
            maximum,
            maxLength,
            maximumNumberOfDecimals,
            validateFunc,
          })
        }
        data-testid="formik-hidden"
        {...inputHtml}
      />
      <Error name={name} id={id} />
    </Wrapper>
  );
};

Hidden.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  validate: PropTypes.shape({
    required: PropTypes.bool,
    minimum: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maximum: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxLength: PropTypes.number,
    maximumNumberOfDecimals: PropTypes.number,
    validateFunc: PropTypes.func,
  }),
  wrapperHtml: PropTypes.object,
  inputHtml: PropTypes.object,
};

export default connect(Hidden);
